import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TabsSliderModule } from '../tabs-slider/tabs-slider.module';
import { TabsComponent } from './tabs.component';

@NgModule({
  declarations: [TabsComponent],
  imports: [CommonModule, TabsSliderModule],
  exports: [TabsComponent]
})
export class TabsModule { }
